module.exports = __webpack_public_path__ + "images/icons_v2/arrow-right-e78eb765.svg";